import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';
import { useConfirmState } from '../hooks/useAppBack';

/**
 * The single mount point for the unsaved-changes confirm opened by the
 * browser-back interception layer (useAppBack). Mounted once in App —
 * pages only call useAppBack, never render the dialog themselves.
 */
export default function AppBackConfirmHost() {
  const { t } = useTranslation();
  const { open, onLeave, onStay } = useConfirmState();

  return (
    <ConfirmDialog
      open={open}
      title={t('common.unsavedChangesTitle')}
      message={t('common.unsavedChangesBody')}
      confirmLabel={t('common.leave')}
      cancelLabel={t('common.stay')}
      onConfirm={onLeave}
      onCancel={onStay}
    />
  );
}
